const signOutPortalOnly = async () => {
  await fetch("/api/auth/logout/portal-only");
};

export default signOutPortalOnly;
